import classNames from 'classnames';
import * as _ from 'lodash';
import { ReactNode } from 'react';

import { setupForDark } from '@theme';

export default function Checkbox({
  children,
  selected = false,
  disabled = false,
  onClick = _.noop,
  className = ''
}: {
  children: ReactNode;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}) {
  onClick = disabled ? _.noop : onClick;

  return (
    <div
      className={classNames(
        'flex flex-row items-start justify-start gap-md',
        'py-sm px-xl rounded-xs',
        setupForDark('border-dropdown'),
        setupForDark(selected ? 'bg-toggle-btn-selected' : 'bg-gray-300'),
        disabled ? '' : 'cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      <div
        className={classNames(
          'P3R',
          'flex-grow',
          disabled ? setupForDark('text-secondary') : setupForDark('text-primary'),
          setupForDark(selected ? 'text-toggle-btn-selected' : 'text-secondary')
        )}
      >
        {children}
      </div>
    </div>
  );
}
